import React from 'react';

const SubHeading = (props) => <span style = {props.style} className={'ds-u-sans ds-title'} {...props}>{props.children}</span>;

export default SubHeading;